import { render, staticRenderFns } from "./SeatingArea.vue?vue&type=template&id=7ae14fb6"
import script from "./SeatingArea.vue?vue&type=script&lang=js"
export * from "./SeatingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports